<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
    <div>
      <img src="@/assets/images/language.png" style="opacity: 0.8; width: 33px; height: 33px; margin-top: 7px" />
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-tooltip :content="$t('others.chinese')" placement="right">
        <el-dropdown-item :disabled="language === 'zh_CN'" command="zh_CN">中文简体</el-dropdown-item>
      </el-tooltip>
      <!-- <el-tooltip :content="$t('others.chinese')" placement="right">
        <el-dropdown-item :disabled="language === 'zh_TW'" command="zh_TW">中文繁體</el-dropdown-item>
      </el-tooltip> -->
      <el-tooltip :content="$t('others.english')" placement="right">
        <el-dropdown-item :disabled="language === 'en'" command="en">English</el-dropdown-item>
      </el-tooltip>
      <el-tooltip :content="$t('others.japanese')" placement="right">
        <el-dropdown-item :disabled="language === 'ja'" command="ja">日本語</el-dropdown-item>
      </el-tooltip>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  inject: ['reload'],
  computed: {
    language() {
      return this.$store.getters.language;
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.reload();
      this.$i18n.locale = lang;
      this.$store.dispatch('SetLanguage', lang);
      this.$message({
        message: this.$t('others.langModified'),
        type: 'success'
      });

      setTimeout(() => {
        window.location.reload();
      }, 100)
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/LangSelect/index.vue